import React, { useContext, useEffect, useState } from "react"
import { View } from "react-native"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { ChampionImageM } from "../../student/champions/ChampionImageM"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

const STORAGE_KEY = "school_assessments_intro_shown"

const SchoolAssessmentsIntroModal = ({ forceShow = false, onDismiss }) => {
    const [visible, setVisible] = useState(false)
    const dimensions = useContext(DimensionsContext)

    useEffect(() => {
        checkIfShouldShow()
    }, [])

    const checkIfShouldShow = async () => {
        if (forceShow) {
            setVisible(true)
            return
        }
        try {
            const hasShown = await AsyncStorage.getItem(STORAGE_KEY)
            if (!hasShown) {
                setVisible(true)
            }
        } catch (error) {
            console.log("Error checking intro modal status:", error)
        }
    }

    const handleClose = async () => {
        try {
            await AsyncStorage.setItem(STORAGE_KEY, "true")
        } catch (error) {
            console.log("Error saving intro modal status:", error)
        }
        setVisible(false)
        onDismiss?.()
    }

    const width = dimensions?.width > 800 ? 400 : dimensions?.width - 40

    return (
        <ModalM
            visible={visible}
            onDismiss={handleClose}
            dismissable={true}
            style={{ width, maxWidth: "95%" }}
        >
            <View
                style={{
                    padding: 24,
                    alignItems: "center",
                }}
            >
                {/* Icon */}
                <View
                    style={{
                        backgroundColor: theme.colors.primaryLighter,
                        borderRadius: 50,
                        padding: 20,
                        marginBottom: 20,
                    }}
                >
                    <FontAwesome5
                        name="calendar-check"
                        size={40}
                        color={theme.colors.primary}
                    />
                </View>

                {/* Title */}
                <TextM
                    fontWeight="Bold"
                    fontSize={22}
                    color={theme.colors.primary}
                    style={{ textAlign: "center", marginBottom: 16 }}
                    wrap
                >
                    Le suivi des contrôles fait son arrivée !
                </TextM>

                {/* Description */}
                <TextM
                    fontSize={15}
                    color={theme.colors.dark}
                    style={{ textAlign: "center", lineHeight: 22, marginBottom: 24 }}
                    wrap
                >
                    Ajoute le prochain contrôle de ton élève pour suivre la progression de sa préparation !
                </TextM>

                {/* Features list */}
                <View
                    style={{
                        backgroundColor: theme.colors.lighter,
                        borderRadius: 12,
                        padding: 16,
                        width: "100%",
                        marginBottom: 24,
                    }}
                >
                    <FeatureItem
                        icon="plus-circle"
                        text="Ajoute les contrôles à venir"
                    />
                    <FeatureItem
                        icon="chart-line"
                        text="Suis la progression de préparation"
                    />
                    <FeatureItem
                        icon="file-alt"
                        text="Les parents les retrouvent dans le rapport de live"
                    />
                </View>

                {/* CTA Button */}
                <FilledButtonM
                    onPress={handleClose}
                    label="Compris !"
                    color={theme.colors.primary}
                    style={{
                        width: "100%",
                        borderRadius: 10,
                    }}
                />
            </View>
        </ModalM>
    )
}

const FeatureItem = ({ icon, text }) => (
    <View
        style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 10,
        }}
    >
        <FontAwesome5
            name={icon}
            size={16}
            color={theme.colors.primary}
            style={{ width: 24 }}
        />
        <TextM
            fontSize={14}
            color={theme.colors.dark}
            style={{ marginLeft: 10, flex: 1 }}
            wrap
        >
            {text}
        </TextM>
    </View>
)

export default SchoolAssessmentsIntroModal
